export type HolidayBannerBackground = 'black-gold' | 'purple';

export type HolidayBannerTextPart = {
  text: string;
  bold?: boolean;
};

export type HolidayBannerConfig = {
  startDate: string;
  endDate: string;
  textParts: HolidayBannerTextPart[];
  background: HolidayBannerBackground;
  campaignUrl?: string;
};

/**
 * Default banner configuration (purple background)
 * Shown when no scheduled banner is active
 */
export const DEFAULT_HOLIDAY_BANNER: HolidayBannerConfig = {
  startDate: '',
  endDate: '',
  textParts: [{ text: 'Free Shipping', bold: true }, { text: ' for orders above {{threshold}}' }],
  background: 'purple',
};

/**
 * Holiday Banner rotation schedule
 * All times are in SGT (Asia/Singapore timezone)
 * Format: 'YYYY-MM-DD HH:mm:ss'
 */
export const HOLIDAY_BANNER_ROTATIONS: HolidayBannerConfig[] = [
  // Phase 1: Mega Spring Sale - Mar 18 (4PM) - Mar 25 (4PM)
  {
    startDate: '2026-03-18 16:00:00',
    endDate: '2026-03-25 16:00:00',
    textParts: [
      { text: 'Mega Spring Sale: ', bold: true },
      { text: '80% OFF of Flash Sale' },
    ],
    background: 'purple',
  },
  // Phase 2: Extended Spring Sale - Mar 25 (4PM) - Apr 1 (4PM)
  {
    startDate: '2026-03-25 16:00:00',
    endDate: '2026-04-01 16:00:00',
    textParts: [
      { text: 'Extended Spring Sale: ', bold: true },
      { text: 'Up to 70% OFF' },
    ],
    background: 'purple',
  },
];

export const HOLIDAY_BANNER_TIMEZONE = 'Asia/Singapore';
